












































































































































import {
  ComponentInternalInstance,
  getCurrentInstance,
  watch,
  computed,
  defineComponent,
  onMounted,
  ref,
  toRefs,
} from '@vue/composition-api';
import {
  CheckCircleFilledIcon,
  ErrorCircleFilledIcon,
  InfoCircleFilledIcon,
  ChevronDownCircleIcon,
} from 'tdesign-icons-vue';
import _ from 'lodash';
import qrcode from 'qrcode';
import i18n, { i18n_t } from '@/locales/i18n';
import accountAssociationHandler from '@/renderer/views/desktop/ManageConsole/AccountAssociation/composition/accountAssociationHandler';
import tips from '@/renderer/scripts/utils/tips';
import { transformErrorForSerialization } from '@/common/tools';
export default defineComponent({
  components: {
    CheckCircleFilledIcon,
    ErrorCircleFilledIcon,
    InfoCircleFilledIcon,
    ChevronDownCircleIcon,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    status: {
      type: String,
      default: '',
    },
  },
  setup(props, context) {
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const currComponent: ComponentInternalInstance = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const store = vm.$store;
    const { status } = toRefs(props);
    /**
     * 代开发流程
     * 1. 获取二维码，企微管理员扫码后进行授权。完成后status === 'installed'
     * 2. 用户手动在企微管理控制台进行配置，配置完成后点击【我已配置】。完成后status === 'authorized'
     *    或者管理员驳回后，回到第二步。此时的status === 'rejected'
     * 3. 配置成功后，网盘运维人员对该应用进行手动开发和上线(联调时可使用接口直接上线)。完成后status === 'online'
     * 4. 上线后，用户在企微管理控制台选择可见范围。完成后status==='active'
     */
    const stepList = ['', 'installed', 'authorized', 'online', 'active'];

    // 代开发应用
    const step = ref(0); // 正在进行的步骤
    const finishedStep = ref(0); // 已完成的步骤
    const { loadingCode, qrCodeUrl, methods: associationMethods } = accountAssociationHandler();
    let timer: number | undefined = 0;
    const methods = {
      // 绘制二维码
      drawQRCode(url: string) {
        if (!url) return;
        const ele = document.getElementById('wecomQrCode') as HTMLCanvasElement;
        qrcode.toCanvas(
          ele,
          url,
          {
            width: 160,
            margin: 0,
          },
          (error: any) => {
            if (error) logger.ui.error('绘制二维码失败', transformErrorForSerialization(error));
          },
        );
      },
      // 绘制授权二维码
      async drawDelegateQrCode() {
        await associationMethods.getWeworkDelegateQrcode();
        methods.drawQRCode(qrCodeUrl.value);
        if (qrCodeUrl.value) {
          // 成功生成二维码后开始轮询监听;
          methods.watchStatus();
        }
      },
      // 开始轮询检测配置状态
      watchStatus() {
        if (timer) return;
        timer = window.setInterval(() => {
          // 通知父组件查询企微配置
          context.emit('refresh');
        }, 5000);
      },
      cancelWatchStatus() {
        window.clearInterval(timer);
        timer = undefined;
      },
      // 获取代开发应用当前步骤
      getDelegateStep() {
        step.value = stepList.indexOf(status.value) + 1;
        finishedStep.value = step.value - 1;
        // 驳回状态特殊处理，
        if (status.value === 'rejected') {
          finishedStep.value = 1;
          step.value = 2;
        }
      },
      // 选择自建应用or代开发应用
      choose(type: 'self' | 'other') {
        context.emit('choose-wework-type', type);
        methods.onClose();
      },
      // 手动我已配置
      async handleConfig() {
        await associationMethods.weworkAuthorized();
        methods.cancelWatchStatus();
        context.emit('refresh');
        methods.watchStatus();
      },
      // 手动我已上线
      async handleOnline() {
        await associationMethods.weworkOnline();
        methods.cancelWatchStatus();
        context.emit('refresh');
        methods.watchStatus();
      },
      onClose() {
        methods.cancelWatchStatus();
        innerShow.value = false;
      },
    };
    watch(
      () => step.value,
      val => {
        if (val === 1) {
          // 新应用第一步需要二维码
          if (!status.value) {
            methods.drawDelegateQrCode();
          }
        }
      },
    );

    watch(
      () => props.status,
      val => {
        if (!val) {
          // 处理配置中断
          tips.error(i18n_t('配置异常，请重新配置'));
          methods.onClose();
          return;
        }
        finishedStep.value = stepList.indexOf(val);
        step.value = Math.min(finishedStep.value + 1, stepList.length - 1);
        // 驳回状态特殊处理，
        if (val === 'rejected') {
          finishedStep.value = 1;
          step.value = 2;
        }
        if (status.value === 'active') {
          // 完成所有配置
          window.clearInterval(timer);
          timer = undefined;
        } else {
          methods.watchStatus();
        }
      },
    );

    onMounted(() => {
      methods.getDelegateStep();
      // associationMethods.getWeworkConfig();
      // 先绘制一个二维码占位
      methods.drawQRCode('loading...');
      // 开始监听状态
      methods.watchStatus();
    });
    return {
      innerShow,
      step,
      loadingCode,
      qrCodeUrl,
      finishedStep,
      ...methods,
      associationMethods,
    };
  },
});
